import { render, staticRenderFns } from "./MaintenancePanelSupervisorExpanded.vue?vue&type=template&id=2a35f6a2&"
import script from "./MaintenancePanelSupervisorExpanded.vue?vue&type=script&lang=ts&"
export * from "./MaintenancePanelSupervisorExpanded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports